import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { GetReportGroupFiltersResponse } from '@/api/generatedApi';

export const REPORT_GROUP_FILTERS_QUERY_KEY = 'reports.groupFilters';

export const useGetReportGroupFilters = ({
  reportId,
  groupId,
  enabled = true,
}: {
  reportId: string;
  groupId: string;
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: [REPORT_GROUP_FILTERS_QUERY_KEY, { reportId, groupId, tenantId }],
    queryFn: () => {
      return api.tenants.getReportGroupFilters(tenantId, reportId, groupId);
    },
    enabled: enabled && !!tenantId && !!reportId && !!groupId,
  });

  return {
    data: data?.data as GetReportGroupFiltersResponse | undefined,
    isLoading,
    error,
  };
};
